import React from 'react';

export const UserProfile = () => {
  return <>UserProfile</>;
};
